import React from "react"
import { Bounds, Box } from "../grid"
import { FontIcon, YekanParagraph } from "../typography"
import {
  FeatureList as Styled,
  FeatureRow,
  FeatureTitle,
  Ticks,
} from "./styled"

export const Icon = ({ data, slug }) => {
  if (data === true)
    return <Ticks slug={slug} className="icon-tick" fontSize="1.4rem" />
  if (data === false) return <span style={{ fontSize: "1.4rem" }}>--</span>
  return <span style={{ fontSize: "1.4rem" }}>{data}</span>
}

const FeatureList = ({ features, services, slug }) => {
  return (
    <Styled slug={slug}>
      {Object.keys(features).map(feature => {
        const featureData = services[feature]

        return (
          featureData !== undefined && (
            <FeatureRow>
              <Bounds>
                <FeatureTitle flex="1 0 0" slug={slug}>
                  <FontIcon className="icon-bullet" fontSize="0.8rem" />
                  <YekanParagraph>{features[feature]}</YekanParagraph>
                </FeatureTitle>
                <Box flex="0 1 0">
                  <Icon data={featureData} slug={slug} />
                </Box>
              </Bounds>
            </FeatureRow>
          )
        )
      })}
    </Styled>
  )
}

export default FeatureList
